import {AccessibilityInfo} from 'react-native';

import {ExitPopup} from '/component/base/ExitPopup';
import {ACTION_TYPES, EVENT_NAMES} from '/enum/tealium.enum';
import {CrashlyticsBackend} from '/util/error-tracking/crashlytics';
import {getTealiumUtilDefaultInstance} from '/util/tealium';
import {validateEmail, validateName} from '/util/validation.util';

import DeleteProfilePopover from '../../../partial/DeleteProfilePopover';

const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
  eventName: EVENT_NAMES.profileUpdate,
});
export const changeNum = (num: any) =>
  num ? num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : num;

export const generateOpenDeletePopover = (
  {popoverShow}: any,
  handleDeleteProfile: any,
) => {
  return () => {
    popoverShow(DeleteProfilePopover, {
      onSubmit: () => handleDeleteProfile,
    });
  };
};

export const handleBackButton = ({
  name,
  phoneNumber,
  email,
  newName,
  newEmail,
  newPhone,
  navigation,
  showPopup,
  hidePopup,
}: any) => {
  if (name !== newName || phoneNumber !== newPhone || email !== newEmail) {
    showPopup(
      ExitPopup,
      {
        title: 'Are you sure you want to go back?',
        description: 'All unsaved changes will be lost.',
        alignButtonsAsColumn: true,
        handleCancelButton: hidePopup,
        handleDiscardButton: async () => {
          await hidePopup();
          navigation.goBack();
        },
        exitButton: hidePopup,
      },
      {avoidable: false, showFullModal: false},
    );
  } else {
    navigation.goBack();
  }
};

const saveCandidateProfileData = async ({
  name,
  email,
  cleanedNumber,
  urlDetailsData,
}: any) => {
  return {
    name: name,
    phone: cleanedNumber,
    email: email,
    urlDetails: urlDetailsData,
  };
};
const fetchCandidateEvent = async ({
  name,
  phoneNumber,
  email,
  newName,
  newEmail,
  newPhone,
  urlDetailsData,
}: any) => {
  let filterStr = '';
  const cleanedNumber = phoneNumber.replace(/\D/g, '');

  if (name !== newName) {
    filterStr += `${name},`;
  }
  if (phoneNumber !== newPhone) {
    filterStr += `${cleanedNumber},`;
  }
  if (email !== newEmail) {
    filterStr += `${email},`;
  }
  if (urlDetailsData) {
    filterStr += `${urlDetailsData}`;
  }

  if (filterStr.endsWith(',')) {
    filterStr = filterStr.slice(0, -1);
  }

  return filterStr;
};

export const handleSave = async ({
  name,
  email,
  phoneNumber,
  newName,
  newEmail,
  newPhone,
  urlDetailsData,
  setFetchApi,
  setNameError,
  setPhoneNumberError,
  setEmailError,
  setSocialLinksError,
  saveEditCandidateProfile,
  socialLinkText,
  navigation,
  setSocialLinks,
  candidateId,
  lastPaidRank,
}: any) => {
  if (urlDetailsData === null) {
    urlDetailsData = []; // when userDetails comes from leads pool we need to conver then in []
  }
  const cleanedNumber = phoneNumber.replace(/\D/g, '');
  setFetchApi(true);
  const isNameValid = !validateName(name);
  setNameError(!isNameValid);
  const isPhoneNumberValid = cleanedNumber.length === 10;
  setPhoneNumberError(!isPhoneNumberValid);
  const isEmailValid = validateEmail(email);
  setEmailError(!isEmailValid);
  const pattern = /^((http|https|Https|Http|ftp|Ftp):\/\/)/;
  // social link url validation
  let hasSocialLinksError = false;
  for (let pair of socialLinkText) {
    const [key, value] = pair || [];
    setSocialLinksError(false);
    if (
      !value ||
      (key && !value.url) ||
      !pattern.test(value?.url?.toString())
    ) {
      setSocialLinksError(true);
      hasSocialLinksError = true;
      break;
    }
    urlDetailsData = [...urlDetailsData, value];
  }
  const filteredArray = urlDetailsData
    .filter((item: any) => item.type !== undefined)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    .map(({id, ...rest}: any) => rest);

  // field validation .......
  if (
    !isNameValid ||
    !isPhoneNumberValid ||
    !isEmailValid ||
    hasSocialLinksError
  ) {
    setFetchApi(false);
    return;
  }
  try {
    // api request formation......
    const candidateProfileData = await saveCandidateProfileData({
      name,
      email,
      cleanedNumber,
      urlDetailsData: filteredArray,
    });

    //  api call.....
    await saveEditCandidateProfile(candidateProfileData);
    AccessibilityInfo.announceForAccessibility('Candidate saved successfully');

    setSocialLinks([]);
    const CandidateEventStr = await fetchCandidateEvent({
      name,
      phoneNumber,
      email,
      newName,
      newEmail,
      newPhone,
      urlDetailsData,
    });
    sendEvent({
      userId: candidateId,
      updated_fields: CandidateEventStr,
      action: ACTION_TYPES.edit,
      lastPaidRank: lastPaidRank,
    });
  } catch (error) {
    // Add accessibility announcement for failed save
    AccessibilityInfo.announceForAccessibility(
      'Candidate not saved successfully',
    );
    const crashlytics = new CrashlyticsBackend();
    crashlytics.logError(error);
  } finally {
    // navigation after successful candidate save
    setFetchApi(false);
    navigation.goBack();
  }
};
